import app from '../main'
import * as action from './actions'
import axios from 'axios'
import Vue from 'vue'
import {SET_WARNING_DISPOSITION} from "./actions";

export const statelang = {
  lang: 'en'
}

export const mutations = {
  [action.SET_LANG](state, payload) {
    if(app){
      app.$i18n.locale = payload
      app.$session.set('lang', payload)
    }

    axios.defaults.headers.common['Lang'] = payload
    state.lang = payload
  },
  setCategoryUuid(state, categoryUuid) {
    state.category_uuid = categoryUuid
  },
  setSubCategoryUuid(state, subCategoryUuid) {
    state.sub_category_uuid = subCategoryUuid
  },
  [action.SET_SELECTED_PRODUCT](state, product) {
    state.selectedProduct = product
  },
  setSelectedOrderTime(state, orderTime) {
    state.selectedOrderTime = orderTime
  },
  [action.SET_SHOW_MODAL_TAKE_AWAY_LESS](state, payload) {
    state.showModalTakeAwayLess = payload
  },
  [action.SET_CATEGORY_LIST](state, payload) {
    state.categoryList = payload
  },
  [action.SET_ATTRIBUTES_LIST](state, payload) {
    state.attributeList = payload
  },
  [action.SET_ATTRIBUTES_FILTER](state, payload) {
    state.attributeFilter = payload
  },
  [action.SET_IS_VALID_ORDER_TIME](state, isValid) {
    state.isValidOrderTime = isValid
  },
  [action.SET_SELECTED_CART](state, product) {
    state.selectedCart = product
  },
  [action.SET_USER](state, user) {
    state.user = user
  },
  [action.SET_SELECTED_CATEGORY](state, category) {
    state.selectedCategory = category
  },
  [action.SET_SELECTED_SUB_CATEGORY](state, subCategory) {
    state.selectedSubCategory = subCategory
  },
  [action.SET_SELECTED_OUTLET](state, payload) {
    state.selectedOutlet = payload
  },
  [action.SET_HUT_OUTLET_ID](state, payload) {
    state.selectedHutOutletId = payload
  },
  [action.SET_SELECTED_HUT_OUTLET](state, payload) {
    state.selectedHutOutlet = payload
  },
  [action.SET_DISPOSITION](state, payload) {
    state.selectedDisposition = payload
  },
  [action.SET_UI_DIRECTION](state, payload) {
    state.uiDirection = payload
  },
  [action.SET_WARNING_DISPOSITION](state, payload) {
    state.warningDisposition = payload
  },
  setCouponMessage(state, message) {
    state.coupon_message = message
  },
  setMenuDeal(state, menuDeal) {
    state.menu_deal = menuDeal
  },
  [action.SET_UUID_FOR_NAMESEO_DUPLICATE] (state, payload) {
    state.uuidForNameSeoDuplicate = payload
  }
}

export const getters = {
  category_uuid: state => state.category_uuid,
  categoryList: state => state.categoryList,
  sub_category_uuid: state => state.sub_category_uuid,
  coupon_message: state => state.coupon_message,
  menuDeal: state => state.menu_deal,
  selectedCategory: state => state.selectedCategory,
  selectedSubCategory: state => state.selectedSubCategory,
  selectedProduct: state => state.selectedProduct,
  selectedCart: state => state.selectedCart,
  selectedOrderTime: state => state.selectedOrderTime,
  selectedOutlet: state => state.selectedOutlet,
  selectedHutOutletId: state => state.selectedHutOutletId,
  selectedHutOutlet: state => state.selectedHutOutlet,
  isValidOrderTime: state => state.isValidOrderTime,
  selectedDisposition: state => state.selectedDisposition,
  uiDirection: state => state.uiDirection,
  warningDisposition: state => state.warningDisposition,
  user: state => {
    if (state.user) {
      return state.user
    } else {
      return Vue.auth.user()
    }
  },
  lang: state => {
    if (state.lang) {
      return state.lang
    } else {
      return app.$i18n.locale || app.$session.get('lang')
    }
  },
  langList: state => {
    return state.langList
  },
  uuidForNameSeoDuplicate: state => state.uuidForNameSeoDuplicate
}




// WEBPACK FOOTER //
// ./src/store/mutations.js